import { useForm } from 'react-hook-form';

import useSurvey from 'store/survey/useSurvey';
import useNotification from 'hooks/useNotification';

import { Typography, Box } from '@mui/material';
import MuiDialog from 'components/MuiDialog';

import { SurveyDialogProps, TInfectionDefaultValues } from '../type';
import { updateInfection } from 'apis/survey';

import CommonPatientInfo from '../components/CommonPatientInfo';
import Exposure from './Exposure';
import StaffInfo from './StaffInfo';
import Resurt from './Resurt';
import Source from './Source';
import After from './After';
import Signature from './Signature';
import useUser from 'store/user/useUser';

const Infection = (props: SurveyDialogProps<TInfectionDefaultValues>) => {
  const {
    title,
    isOpen,
    disabled,
    defaultValues,
    user_id,
    nurseName,
    patientInfo,
    onClose,
  } = props;

  const { onUpdateIsSave } = useSurvey();
  const { onSuccess, onFail, onResultCode, onRequired } = useNotification();
  const { handleSubmit, watch, getValues, setValue, register } = useForm({
    defaultValues,
  });
  const { student_gender } = useUser();
  // 직원 정보는 작성 회원의 정보다. 작성 화면은 저장될 회원 성별, 교수 보기는 저장된 값을 보여 준다.
  const staffGender = disabled
    ? Number(defaultValues?.info_gender)
    : Number(student_gender || 1);

  const onSubmit = (data: TInfectionDefaultValues) => {
    const {} = data;

    const request = {
      user_id,
      patient_id: patientInfo.patient_id,
      infection_survey: {
        info_name: nurseName,
        info_no: data.info_no ? data.info_no : '',
        info_contact: data.info_contact ? data.info_contact : '',
        info_date: data.info_date ? data.info_date : '',
        info_department: data.info_department ? data.info_department : '',
        info_job: data.info_job ? data.info_job : '',
        info_gender: staffGender,
        info_pregnancy: data.info_pregnancy ? data.info_pregnancy : 1,
        info_pregnancy_input: data.info_pregnancy_input
          ? data.info_pregnancy_input
          : '',

        infection_matters: JSON.stringify(data.infection_matters),
        infection_date: data.infection_date,
        infection_time: data.infection_time ? data.infection_time : '',
        infection_place: data.infection_place,

        infection_left: JSON.stringify(data.infection_left),
        infection_right: JSON.stringify(data.infection_right),
        infection_situation: JSON.stringify(data.infection_situation),
        infection_cause: JSON.stringify(data.infection_cause),
        infection_cause_input: data.infection_cause_input,

        wear_gloves1: data.wear_gloves1 ? data.wear_gloves1 : 2,
        wear_gloves2: data.wear_gloves2 ? data.wear_gloves2 : 2,
        wear_gloves_none: JSON.stringify(data.wear_gloves_none),

        infection_state: JSON.stringify(data.infection_state),
        infection_state_input: data.infection_state_input,

        infection_after: JSON.stringify(data.infection_after),

        infection_after_input: data.infection_after_input,
        infection_after_medi: data.infection_after_medi,
        infection_after_test: data.infection_after_test,

        test_result: data.test_result,
      },
    };

    updateInfection(request)
      .then(({ data: { rc } }) => {
        if (rc !== 1) return onResultCode(rc);

        onUpdateIsSave(true);
        onSuccess('저장되었습니다');
      })
      .catch(e => {
        onFail('저장에 실패하였습니다', e);
      });
  };

  const formProps = {
    disabled,
    watch,
    getValues,
    setValue,
    onSuccess,
    onRequired,
    register,
  };

  return (
    <MuiDialog.SurveyForm
      title={title}
      isOpen={isOpen}
      onClose={onClose}
      onSubmit={disabled ? undefined : handleSubmit(onSubmit)}
      update_at={defaultValues?.update_at}
    >
      <Typography
        sx={{
          margin: '40px auto 40px auto',
          fontWeight: '700',
          fontSize: '16px',
          textAlign: 'center',
        }}
      >
        감염노출 보고서
        <br /> - 테스트중입니다. -
      </Typography>
      <CommonPatientInfo patientInfo={patientInfo} nurseName={nurseName} />
      <Box sx={{ marginTop: '48px' }}>
        <StaffInfo
          {...formProps}
          name={nurseName}
          gender={staffGender}
        />
        <Exposure {...formProps} />
        <Source {...formProps} patientInfo={patientInfo} />
        <After {...formProps} />
        <Resurt {...formProps} />
        <Signature {...formProps} />
      </Box>
    </MuiDialog.SurveyForm>
  );
};

export default Infection;
